import React, { useEffect, useState } from 'react';
import EditAvatarProfileStep from './EditAvatarProfileStep';

function EditAvatarProfileForm(props) {
  const { profileImage, onSubmit, saving } = props;

  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <EditAvatarProfileStep
      profileImage={profileImage}
      onSubmit={handleFormSubmit}
      saving={saving}
    />
  );
}

export default EditAvatarProfileForm;
